import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SecondaryButton.scss';

type Props = {
  label?: string;
  icon?: any;
  loading?: boolean;
  className?: string;
};

const BackButton: React.FC<Props> = ({ label, icon, loading, className }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <Button type="default" className={`btn-secondary ${className}`} loading={loading} onClick={handleBack}>
      {label}
      {icon}
    </Button>
  );
};

export default BackButton;
